import { Link } from "react-router-dom";
import Title from "../components/ui/Title";
import { Button } from "../components/ui/button";
import Box from "../components/ui/Box";

const SuccessAugmentationCheptelPage = () => {
  return (
    <Box className="text-center mt-2 md:mt-8">
      <Title>Paiement validé</Title>
      <div className="my-8">
        Votre paiement a été accepté. Merci pour votre confiance.
      </div>

      {/* Bouton */}
      <Link to="/" replace>
        <Button>Retour à l'accueil</Button>
      </Link>
    </Box>
  );
};

export default SuccessAugmentationCheptelPage;
